import React from 'react';

import { setApp } from '../../../index';

class CheckBoxAgreement extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = { checked: false };
    }

    checkboxCheck(event) {
        var name = this.props.name;
        var curState = !this.state.checked;
        this.setState({ checked: curState });
        setApp(name, curState);
        if (curState === true) {
            setApp('blockAgreements', false);
        } else {
            setApp('blockAgreements', true);
        }
    }

    render() {
        return (
            <div className="membership-qualification-checkbox hug">
                <input type="checkbox" name={this.props.name} defaultChecked={this.state.checked} className="pull-left loanApp-form-control" onChange={this.checkboxCheck.bind(this)} />
                <label htmlFor={this.props.name}>{this.props.label}</label>
            </div>
        )
    }
}

export default CheckBoxAgreement;